/* unplugin-vue-components disabled */import script from "./wecharList.vue?vue&type=script&setup=true&lang=js"
export * from "./wecharList.vue?vue&type=script&setup=true&lang=js"

import "./wecharList.vue?vue&type=style&index=0&id=f06c8770&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f06c8770"]])

export default __exports__